import { useCartIdAtom, useFormMessageAtom } from '$src/hooks/state';

export const useBaseApiUrl = (): string | undefined => {
  const { formMessage } = useFormMessageAtom();
  const { cartId } = useCartIdAtom();
  return formMessage?.shopId && cartId
    ? `/api/${encodeURIComponent(formMessage.shopId)}/${encodeURIComponent(cartId)}`
    : undefined;
};
